/*eslint-disable */
import React, { useEffect, useState } from "react";
import { withFormik, Form as Formiker, Field as Fieldmik, FieldArray } from "formik";
import * as yup from "yup";
import moment from "moment";
import {
  Form as FormUi,
  Container,
  TextArea,
  Button,
  Input,
  Segment,
  Dropdown,
  Divider,
  Icon,
  Search,
} from "semantic-ui-react";
import { MyNormalInput, MyTextArea } from "../dynamicComponent/myInputs";
import { translate } from "react-i18next";
import BillingPartyBranch from "../dropdowns/billingPartyBranch";
import cogoToast from "cogo-toast";
import { connect } from "react-redux";
import { DateData } from "../dynamicComponent/datepick";
import BranchDropdown from "../dropdowns/branchDropdown";

/* NEW BOOKINGS */
import InsertBookingRequestDomestic from "./insertBookingRequestDomestic";
import InsertBookingRequestExport from "./insertBookingRequestExport";
import InsertBookingRequestImport from "./insertBookingRequestImport";

/* EDIT BOOKINGS */
import InsertBookingRequestDomesticEdit from "./insertBookingRequestDomesticEdit";
import InsertBookingRequestExportEdit from "./insertBookingRequestExportEdit";
import InsertBookingRequestImportEdit from "./insertBookingRequestImportEdit";

import { useHistory } from "react-router-dom";
import {FEATURES , DATE_FORMATS} from '../../utils/constant'

const InsertBookingRequest = ({
  t,
  touched,
  errors,
  values,
  setFieldValue,
  ...props
}) => {
  useEffect(() => {
    if (props.mode != "edit") {
      setFieldValue("requested_booking_date", moment.tz(moment(new Date()).format(DATE_FORMATS.YYYYMMDD_HHMM), 'Asia/Kolkata'));
    }
  }, [props.bookingRequestObj]);

  const [masterState, setMasterState] = useState("");
  const getMasterBranchSelected = (branchCode, branchData) => {
    const addedMasterBranchObject = branchData.find(
      (data) => data.branchId === branchCode
    );
    //setMasterState(addedMasterBranchObject.stateId);
  };
  const history = useHistory();

  const routeBackToListing = () => {
    history.push("/booking-request");
  };
  return (
    <div>
      <Formiker>
        {/* <AddTitleBar Title="Create Rate Engine" LinkName="/rate-engine" /> */}

        <Segment>
          <div className="ui form tiny">

            <FieldArray name="MovementDetails">

              <div key="MovementDetails" className="list-group list-group-flush">
                <div className="list-group-item padding-0-imp mt-4">
                  <>
                    <div className="form-row display-flex-center-justify-spacebtwn">
                      <div className="form-group col-4">
                        <div>
                          <label className="required-form-element">
                            {t("shipment_form.movement_type.title") || "Movement Type"}
                          </label>
                        </div>
                        <div className="adjust-width-cell">
                          <Dropdown
                            name="movement_type"
                            disabled={props.mode == "view" ? true : false}
                            clearable
                            search
                            error={
                              touched.movement_type && errors.movement_type
                                ? true
                                : false
                            }
                            style={{ width: "100%" }}
                            selection
                            placeholder={""}
                            onChange={(name, data) => {
                              setFieldValue("movement_type", data.value);
                            }}
                            options={[
                              { key: "3", text: "Primary", value: "primary" },
                              { key: "2", text: "Import", value: "import" },
                              { key: "4", text: "Export", value: "export" },
                            ]}
                            value={values.movement_type}
                          />
                        </div>
                      </div>
                      <div className="form-group col-3"></div>
                      <div className="form-group col-4">
                        <div>
                          <label>
                            {t("shipment_form.booking_number.title") ||
                              "Booking Number"}
                          </label>
                        </div>
                        <div className="adjust-width-cell">
                          <Fieldmik component={MyNormalInput} name="booking_number" disabled={props.mode == "view" ? true : false} />
                        </div>
                      </div>
                      <div className="form-group col-1"></div>
                    </div>

                    <div className="form-row display-flex-center-justify-spacebtwn">
                      <div className="form-group col-4">
                        <div>
                          <label className="required-form-element">
                            {t("shipment_form.booking_date_time.title") ||
                              "Booking Date & Time"}
                          </label>
                        </div>
                        <div className="adjust-width-cell">
                          <DateData
                            name="requested_booking_date"
                            isClearable={false}
                            disabled={props.mode == "view" ? true : false}
                            autoComplete="off"
                            showTimeSelect
                            timeFormat={DATE_FORMATS.HHmm}
                            readOnly={FEATURES.bookingDateReadOnly}
                            defaultValue={values.requested_booking_date}
                            popperClassName="dateTime"
                            dateFormat={DATE_FORMATS.ddMMyyy_HHmm}
                            timeIntervals={5}
                            customInput={
                              <Input
                                icon="time"
                                className="poupDate"
                                iconPosition="left"
                              />
                            }
                            error={
                              touched.requested_booking_date &&
                                errors.requested_booking_date
                                ? true
                                : false
                            }
                          />
                        </div>
                      </div>
                      <div className="form-group col-3"></div>
                      <div className="form-group col-4">
                        <div>
                          <label className="required-form-element">
                            {t("shipment_form.booking_branch.title") ||
                              "Booking Branch"}
                          </label>
                        </div>
                        <div className="adjust-width-cell">
                          <Fieldmik
                            style={{ width: "100%" }}
                            component={BranchDropdown}
                            disabled={props.mode == "view" ? true : false}
                            name="branch"
                            placeholder={values.branch_placeholder}
                            getMasterBranchSelected={getMasterBranchSelected}
                          />
                        </div>
                      </div>
                      <div className="form-group col-1"></div>
                    </div>

                    <div className="form-row display-flex-center-justify-spacebtwn">
                      <div className="form-group col-4">
                        <div>
                          <label className={FEATURES.creditCheckRequired ? "required-form-element" : ""}>
                            {t("shipment_form.expected_billing_amount.title") ||
                              "Expected Billing Amount"}
                          </label>
                        </div>
                        <div className="adjust-width-cell">
                          <Fieldmik
                            style={{ width: "100%" }}
                            component={MyNormalInput}
                            type="Number"
                            disabled={props.mode == "view" ? true : false}
                            name="expected_billing_amount"
                            value={values.expected_billing_amount}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                </div>
              </div>
            </FieldArray>

            {values.movement_type != "" ? (
              <>
                {values.movement_type === "primary" && props.mode != 'edit' && props.mode != 'view' ? (
                  <>
                    <InsertBookingRequestDomestic
                      movement_type={values.movement_type}
                      booking_number={values.booking_number}
                      requested_booking_date={values.requested_booking_date}
                      branch={values.branch}
                      bookingRequestObj={props.bookingRequestObj}
                      mode={props.mode}
                      routeBackToListing={routeBackToListing}
                      bookingValues={values}
                    ></InsertBookingRequestDomestic>
                  </>
                ) : (
                  ""
                )}

                {values.movement_type === "primary" && (props.mode == 'edit' || props.mode == 'view') ? (
                  <>
                    <InsertBookingRequestDomesticEdit
                      movement_type={values.movement_type}
                      booking_number={values.booking_number}
                      requested_booking_date={values.requested_booking_date}
                      branch={values.branch}
                      bookingRequestObj={props.bookingRequestObj}
                      mode={props.mode}
                      routeBackToListing={routeBackToListing}
                      bookingValues={values}
                    ></InsertBookingRequestDomesticEdit>
                  </>
                ) : (
                  ""
                )}

                {values.movement_type === "import" && props.mode != 'edit' && props.mode != 'view' ? (
                  <>
                    <InsertBookingRequestImport
                      movement_type={values.movement_type}
                      booking_number={values.booking_number}
                      requested_booking_date={values.requested_booking_date}
                      branch={values.branch}
                      bookingRequestObj={props.bookingRequestObj}
                      mode={props.mode}
                      routeBackToListing={routeBackToListing}
                      bookingValues={values}
                    ></InsertBookingRequestImport>
                  </>
                ) : (
                  ""
                )}

                {values.movement_type === "import" && (props.mode == 'edit' || props.mode == 'view') ? (
                  <>
                    <InsertBookingRequestImportEdit
                      movement_type={values.movement_type}
                      booking_number={values.booking_number}
                      requested_booking_date={values.requested_booking_date}
                      branch={values.branch}
                      bookingRequestObj={props.bookingRequestObj}
                      mode={props.mode}
                      routeBackToListing={routeBackToListing}
                      bookingValues={values}
                    ></InsertBookingRequestImportEdit>
                  </>
                ) : (
                  ""
                )}

                {values.movement_type === "export" && props.mode != 'edit' && props.mode != 'view' ? (
                  <>
                    <InsertBookingRequestExport
                      movement_type={values.movement_type}
                      booking_number={values.booking_number}
                      requested_booking_date={values.requested_booking_date}
                      branch={values.branch}
                      bookingRequestObj={props.bookingRequestObj}
                      mode={props.mode}
                      routeBackToListing={routeBackToListing}
                      bookingValues={values}
                    ></InsertBookingRequestExport>
                  </>
                ) : (
                  ""
                )}

                {values.movement_type === "export" && (props.mode == 'edit' || props.mode == 'view') ? (
                  <>
                    <InsertBookingRequestExportEdit
                      movement_type={values.movement_type}
                      booking_number={values.booking_number}
                      requested_booking_date={values.requested_booking_date}
                      branch={values.branch}
                      bookingRequestObj={props.bookingRequestObj}
                      mode={props.mode}
                      routeBackToListing={routeBackToListing}
                      bookingValues={values}
                    ></InsertBookingRequestExportEdit>
                  </>
                ) : (
                  ""
                )}
              </>
            ) : (
              ""
            )}
          </div>
        </Segment>

      </Formiker>
    </div>
  );
};

const FormikShipment = withFormik({
  enableReinitialize: true,
  validationSchema: yup.object({
    movement_type: yup.string().required("required"),
    branch: yup.string().required("required"),
    requested_booking_date: yup.date().required("required")
  }),

  mapPropsToValues: (props) => ({
    movement_type:
      props.bookingRequestObj && props.bookingRequestObj.movement_type
        ? props.bookingRequestObj.movement_type
        : "primary",
    booking_number:
      props.bookingRequestObj && props.bookingRequestObj.booking_number
        ? props.bookingRequestObj.booking_number
        : null,
    requested_booking_date:
      props.bookingRequestObj && props.bookingRequestObj.booking_date
        ? moment(props.bookingRequestObj.booking_date, DATE_FORMATS.YYYYMMDD_HHMM)
        : "",
    branch:
      props.bookingRequestObj && props.bookingRequestObj.booking_branch_id
        ? parseInt(props.bookingRequestObj.booking_branch_id)
        : null,
    branch_placeholder:
      props.bookingRequestObj && props.bookingRequestObj.booking_branch_name
        ? props.bookingRequestObj.booking_branch_name
        : "Branch",
    expected_billing_amount:
        props.bookingRequestObj && props.bookingRequestObj.expected_billing_amount
          ? Number(props.bookingRequestObj.expected_billing_amount)
          : null,
  }),
})(InsertBookingRequest);

const mapStateToProps = ({ }) => {
  return {};
};

export default connect(
  mapStateToProps,
  {}
)(translate("create_booking_request")(FormikShipment));
